import { Channels } from 'generated-graphql/types';

export const channelsAvailable = [
  Channels.Whatsapp,
  Channels.Sms,
  Channels.Email
];
